const global_ = globalThis;
const self_ = globalThis.self || globalThis.window || globalThis.global;
const window_ = globalThis.window || globalThis.self || globalThis.global;
const document_ = globalThis.document || {};
const process_ = globalThis.process || {};
const console_ = globalThis.console;
const navigator_ = globalThis.navigator || {};
export { global_ as global, self_ as self, window_ as window, document_ as document, process_ as process, console_ as console, navigator_ as navigator };
//# sourceMappingURL=globals.js.map